export default "__VITE_ASSET__9259066f__"